import { sharingSteps } from './ProjectSharing';
import { ProjectSharingHeader } from './ProjectSharingHeader';
import styles from './project-sharing.module.less';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { ProjectSharingFooter } from './ProjectSharingFooter';
import { MarkAsCompleteButton } from './ProjectSharingMarkAsComplete';
import { getUrlFromShortlink } from '../../shortlink/shortlink-model';
import Image from '../../components/image/Image';
import CopyTextButton from '../../components/button/copy-text-button/CopyTextButton';

export const ProjectSharingFriends = ({ setSharingStepComplete, project, completed, shortlink }) => {
    const urlToShare = shortlink ? getUrlFromShortlink(shortlink) : `https://spleis.no/${project.id}`;
    const text = `Hei! Jeg har nettopp startet innsamlingen «${project.title}» på Spleis. For at den skal lykkes trenger jeg litt hjelp av deg. Kan du hjelpe meg å dele innsamlingen?
${urlToShare}`;

    const footerBackLink = `/project/${project.id}/sharing/2`;
    const footerBackLinkText = 'Facebook';
    const footerForwardLink = `/project/${project.id}/sharing/4`;
    const footerForwardLinkText = 'Grupper og fellesskap';
    return (
        <>
            <ProjectSharingHeader
                title="Send til støttespillere"
                backLink={`/project/${project.id}/sharing`}
                backLinkText="Tilbake til delingspanelet"
            />
            <div className={styles.contentPanel}>
                <Image
                    className={styles.topImage}
                    src="people-illustrations/walk-high-five.svg"
                    title="venner"
                    alt="2 personer som gir hverandre high-five"
                />

                <ul className={styles.checkmarkList}>
                    <li>Støttespillere som kan spre innsamlingen sammen med deg er viktig for å gi den en god start</li>
                </ul>

                <div className={styles.messageLabel}>Send dem en melding – bruk gjerne teksten under</div>

                <div className={styles.url}>
                    <CopyTextButton
                        text={text}
                        trackingFunction={() =>
                            trackEvent('admin', 'project-share', {
                                channel: 'copy-text',
                                activity: 'friends',
                                'project-id': project.id,
                            })
                        }
                        className={styles.flatTop}
                    />
                </div>

                <MarkAsCompleteButton
                    completed={completed}
                    onClick={() => {
                        setSharingStepComplete(sharingSteps.friends);
                        trackEvent('shareguide', 'step-complete', {
                            activity: 'friends',
                            'project-id': project.id,
                        });
                    }}
                />
            </div>
            <ProjectSharingFooter
                backLink={footerBackLink}
                backLinkText={footerBackLinkText}
                forwardLink={footerForwardLink}
                forwardLinkText={footerForwardLinkText}
            />
        </>
    );
};
